var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29549 14.6705C7.85616 15.1098 7.14384 15.1098 6.7045 14.6705L0.329501 8.2955C-0.109834 7.85616 -0.109834 7.14384 0.329501 6.70451L6.7045 0.329555C7.14384 -0.109795 7.85616 -0.109795 8.29549 0.329555C8.73483 0.768905 8.73483 1.48111 8.29549 1.92046L3.84099 6.375L15 6.375C15.6213 6.375 16.125 6.87869 16.125 7.5C16.125 8.12132 15.6213 8.625 15 8.625L3.84099 8.625L8.29549 13.0795C8.73483 13.5188 8.73483 14.2312 8.29549 14.6705Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.ab4fb0b50c9e3761ba6597dde5aad467.svg";
export { ForwardRef as ReactComponent };